module.exports = __webpack_public_path__ + "img/checkout-mobile-desktop.bfcd2ddf.svg";